/**
 *  @class
 *  @function ImageTextOverlay
 */

if (!customElements.get('image-with-text-overlay')) {
  class ImageTextOverlay extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
      this.mask = false;
      this.img = this.querySelector('.image-with-text-overlay--bg img');
    }

    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }

      window.addEventListener('load', () => {
        if (this.img && typeof lazySizes !== 'undefined' && lazySizes.loader) {
          lazySizes.loader.unveil(this.img);
        }
      });
    }

    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        if (this.tl) {
          this.tl.kill();
        }
        if (this.tl && this.tl.scrollTrigger) {
          this.tl.scrollTrigger.kill();
        }
        if (this.splittext) {
          this.splittext.revert();
        }
        if (this.mask) {
          this.mask.revert();
        }
      }
    }

    prepareAnimations() {
      let section = this,
        property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 80%",
          once: true
        }
      });

      document.fonts.ready.then(function () {
        gsap.set(section.querySelectorAll('.image-with-text-overlay--content-inner'), {
          visibility: 'visible'
        });

        section.splittext = new SplitText(
          section.querySelectorAll('.image-with-text-overlay--heading, .rte p'),
          {
            type: 'lines',
            linesClass: 'line-child'
          }
        );

        section.mask = new SplitText(
          section.querySelectorAll('.image-with-text-overlay--heading, .rte p'),
          {
            type: 'lines',
            linesClass: 'line-parent'
          }
        );

        section.tl.from(section.querySelector('.image-with-text-overlay--bg'), {
          scale: 1.08,
          duration: 0.6,
          ease: 'power2.out'
        });

        if (section.querySelector('.inline-badge')) {
          section.tl.fromTo(section.querySelector('.inline-badge'), {
            opacity: 0,
            y: 8
          }, {
            duration: 0.2,
            opacity: 1,
            y: 0,
            ease: 'power2.out'
          }, '>-=0.1');
        }

        if (section.querySelector('.subheading')) {
          section.tl.fromTo(section.querySelector('.subheading'), {
            opacity: 0,
            y: 10
          }, {
            duration: 0.25,
            opacity: 1,
            y: 0,
            ease: 'power2.out'
          }, '>-=0.1');
        }

        if (section.querySelectorAll('.image-with-text-overlay--heading .line-child').length) {
          section.tl.from(section.querySelectorAll('.image-with-text-overlay--heading .line-child'), {
            duration: 0.45,
            yPercent: 100,
            stagger: 0.035,
            rotation: 0.5,
            ease: 'power2.out'
          }, '>-=0.1');
        }

        if (section.querySelectorAll('.rte p .line-child').length) {
          section.tl.from(section.querySelectorAll('.rte p .line-child'), {
            duration: 0.3,
            yPercent: 100,
            stagger: 0.015,
            ease: 'power2.out'
          }, '>-=0.15');
        }

        if (section.querySelectorAll('.button').length) {
          let i = 0;
          section.querySelectorAll('.button').forEach((item) => {
            section.tl.fromTo(item, {
              autoAlpha: 0,
              y: 8
            }, {
              duration: 0.25,
              autoAlpha: 1,
              y: 0,
              ease: 'power2.out'
            }, '>-=' + (i === 0 ? 0.05 : 0));
            i++;
          });
        }
      });

      if (section.querySelector('.thb-parallax-image')) {
        gsap.fromTo(section.querySelectorAll('.thb-parallax-image'), {
          y: '-8%'
        }, {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            scrub: 1,
            start: () => `top bottom`,
            end: () => `bottom top+=${property}`,
            onUpdate: () => {
              property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
            }
          }
        });
      }

      if (Shopify.designMode && section.tl.scrollTrigger) {
        section.tl.scrollTrigger.refresh();
      }
    }
  }

  customElements.define('image-with-text-overlay', ImageTextOverlay);
}